import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _Cat, _br, _p, _br2, _br3;
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import * as SentryBrowser from '@sentry/browser';
import styled from 'styled-components';
import { breakpoints } from '@crehana/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Cat = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-vkrueu-0"
})(["\n  background-position: center;\n  background-size: cover;\n  width: 131px;\n  height: 190px;\n  ", " {\n    width: 250px;\n    height: 350px;\n  }\n  background-image: url('https://static.crehana.com/static/img/crehana-cat-in-jar.png');\n"], /*#__PURE__*/breakpoints.up('sm'));
var Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-vkrueu-1"
})(["\n  max-width: 600px;\n  ", " {\n    max-width: 700px;\n  }\n"], /*#__PURE__*/breakpoints.up('md'));
var CatErrorPage = function CatErrorPage(_ref) {
  var sentryEventId = _ref.sentryEventId,
    sentryInstanceProp = _ref.sentryInstance;
  var sentryInstance = sentryInstanceProp || SentryBrowser;
  return /*#__PURE__*/_jsx("div", {
    className: "flex items-center justify-center w-full h-screen p-12 bg-white",
    children: /*#__PURE__*/_jsxs(Container, {
      className: "flex flex-col w-full h-full md:flex-row sm:h-auto",
      children: [_Cat || (_Cat = /*#__PURE__*/_jsx(Cat, {
        className: "flex-shrink-0"
      })), /*#__PURE__*/_jsxs("div", {
        className: "mt-12 tw-font-pop md:mt-0",
        style: {
          lineHeight: '1.5'
        },
        children: [/*#__PURE__*/_jsx("h2", {
          style: {
            fontSize: 24
          },
          children: "Oops, tenemos un problema..."
        }), _br || (_br = /*#__PURE__*/_jsx("br", {})), _p || (_p = /*#__PURE__*/_jsx("p", {
          className: "mt-4 text-16",
          children: "Nuestro equipo acaba de ser informado y est\xE1 trabajando para solucionarlo. Si quieres ayudar, cu\xE9ntanos qu\xE9 ha pasado a continuaci\xF3n."
        })), _br2 || (_br2 = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "inline-flex items-center justify-center w-full h-auto px-40 py-8 tw-font-semibold text-white cursor-pointer focus:outline-none md:h-48 md:py-0 bg-purple-main hover:bg-secondary-main sm:w-auto",
          onClick: function onClick() {
            // This will show up a dialog like this https://docs.sentry.io/static/571cee86a7dba33e444eb629282ceae8/00d43/user_feedback_widget.png
            sentryInstance.showReportDialog({
              eventId: sentryEventId,
              title: 'Oops, tenemos un problema...',
              subtitle2: 'Si quieres ayudar, cuéntanos qué ha pasado a continuación.'
            });
          },
          children: "Brindar detalles del error"
        }), _br3 || (_br3 = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return window.location.reload();
          },
          className: "p-8 mt-12 text-secondary-main",
          type: "button",
          children: "O puedes intentar recargando la p\xE1gina."
        })]
      })]
    })
  });
};
export var RootErrorBoundaryWithSentry = function RootErrorBoundaryWithSentry(_ref2) {
  var _CatErrorPage;
  var children = _ref2.children,
    sentryInstanceProp = _ref2.sentryInstance;
  var sentryInstance = sentryInstanceProp || SentryBrowser;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    sentryEventId = _useState2[0],
    setSentryEventId = _useState2[1];
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    FallbackComponent: function FallbackComponent() {
      return _CatErrorPage || (_CatErrorPage = /*#__PURE__*/_jsx(CatErrorPage, {
        sentryEventId: sentryEventId,
        sentryInstance: sentryInstance
      }));
    },
    onError: function onError(error, info) {
      sentryInstance.withScope(function (scope) {
        scope.setTag('error_type', 'critical');
        scope.setTag('error_origin', 'root_error_boundary');
        scope.setExtras(info);
        var eventId = sentryInstance.captureException(error);
        setSentryEventId(eventId);
      });
    },
    children: children
  });
};
export default RootErrorBoundaryWithSentry;